import React, {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCommentDots,
    faBars,
    faXmark, faDatabase,
} from "@fortawesome/free-solid-svg-icons";
import "../Styles/Navbar.css";
import {Link} from "react-router-dom";
import {toast} from "react-toastify";

function Navbar() {
    const [nav, setNav] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const openNav = () => {
        setNav(!nav);
    };

    const handleChatBtnClick = () => {
        if (!isButtonDisabled) {
            toast.info("Experiencing high traffic, Please wait a moment.", {
                position: toast.POSITION.TOP_CENTER,
                onOpen: () => setIsButtonDisabled(true),
                onClose: () => setIsButtonDisabled(false),
            });
        }
    };

    return (
        <div className="navbar-section">
            <h1 className="navbar-title">
                <Link to="/">
                    TechiesHub <span className="navbar-sign"><span><FontAwesomeIcon icon={faDatabase}/></span></span>
                </Link>
            </h1>

            {/* Desktop */}
            <ul className="navbar-items">
                <li>
                    <Link to="/" className="navbar-links">
                        Home
                    </Link>
                </li>
                <li>
                    <a href="#services" className="navbar-links">
                        Remote DBA Services
                    </a>
                </li>
                <li>
                    <a href="#middlewares" className="navbar-links">
                        Middlewares
                    </a>
                </li>
                <li>
                    <a href="#databases" className="navbar-links">
                        Databases
                    </a>
                </li>
                <li>
                    <a href="#about" className="navbar-links">
                        About Us
                    </a>
                </li>
            </ul>

            <button
                className="navbar-btn"
                type="button"
                disabled={isButtonDisabled}
                onClick={handleChatBtnClick}
            >
                <FontAwesomeIcon icon={faCommentDots}/> Live Chat
            </button>

            {/* Mobile */}
            <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
                <div onClick={openNav} className="mobile-navbar-close">
                    <FontAwesomeIcon icon={faXmark} className="hamb-icon"/>
                </div>

                <ul className="mobile-navbar-links">
                    <li>
                        <Link to="/" className="navbar-links">
                            Home
                        </Link>
                    </li>
                    <li>
                        <a href="#services" className="navbar-links">
                            Remote DBA Services
                        </a>
                    </li>
                    <li>
                        <a href="#middlewares" className="navbar-links">
                            Middlewares
                        </a>
                    </li>
                    <li>
                        <a href="#databases" className="navbar-links">
                            Databases
                        </a>
                    </li>
                    <li>
                        <a href="#about" className="navbar-links">
                            About Us
                        </a>
                    </li>
                </ul>
            </div>

            {/* Hamburger Icon */}
            <div className="mobile-nav">
                <FontAwesomeIcon
                    icon={faBars}
                    onClick={openNav}
                    className="hamb-icon"
                />
            </div>
        </div>
    );
}

export default Navbar;
